import { Injectable } from '@angular/core';
import { List } from 'immutable';
import {
  DocumentActionsEnum,
  DocumentTypesEnum,
  ICopyDocumentOptions,
} from '../../../document-data/document-data.data';
import { Document } from '../../../document-data/document.model';
import { EstimateStatusesEnum } from '../../../estimate-data/estimate-data.data';
import { Tax } from '../../../settings-data/sub-models/company-settings/tax.model';
import { IDropdownBuilder } from '../../../shared/components/dropdown/dropdown-builder.interface';
import { UtilsService } from '../../../shared/services/utils/utils.service';

@Injectable()
export class DocumentActionsBuilder implements IDropdownBuilder {
  constructor(private _utilsService: UtilsService) {}

  buildDropdown(document: Document): List<List<DocumentActionsEnum>> {
    const documentActions = [];

    if (document.documentType === DocumentTypesEnum.estimate) {
      if (document.states.estimateStatus === EstimateStatusesEnum.approved) {
        documentActions.push(DocumentActionsEnum.decline_document);
      } else if (
        document.states.estimateStatus === EstimateStatusesEnum.declined
      ) {
        documentActions.push(DocumentActionsEnum.approve_document);
      } else {
        documentActions.push(
          DocumentActionsEnum.approve_document,
          DocumentActionsEnum.decline_document
        );
      }

      documentActions.push(DocumentActionsEnum.convert_document_to_invoice);
    }

    documentActions.push(
      DocumentActionsEnum.copy_document,
      DocumentActionsEnum.print_document
    );

    if (document.documentType === DocumentTypesEnum.invoice) {
      documentActions.push(DocumentActionsEnum.export_document_to_xero);
    }

    return List([List(documentActions)]);
  }
}
